import Image from 'next/image';
import { Box } from 'react-scale/components';

const HowItWorks = ({ image }) => (
  <Box type="bordered-gray">
    <div className="px-8 py-14 md:px-6 md:py-12 xl:px-10 xl:py-28 flex justify-center bg-black rounded-xl">
      <span className="hidden md:block">
        <Image
          src={image.src}
          alt={image.alt}
          width={image.width}
          height={image.height}
          unoptimized
          quality={100}
        />
      </span>
      <span className="md:hidden">
        <Image
          src={image?.srcMobile ?? image.src}
          alt={image.alt}
          width={image.widthMobile}
          height={image.heightMobile}
          unoptimized
          quality={100}
        />
      </span>
    </div>
  </Box>
);

export default HowItWorks;
